module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar uptool",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [(_vm.Limits.task_create) ? _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [(_vm.Limits.task_create) ? _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MMdd",
      "placeholder": "请选择任务单创建日期",
      "picker-options": _vm.pickerOptions1
    },
    model: {
      value: (_vm.inputCode),
      callback: function($$v) {
        _vm.inputCode = $$v
      },
      expression: "inputCode"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('span', [_vm._v("流水号：")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "min": 1,
      "max": 99,
      "label": "流水号",
      "size": "mini",
      "controls-position": "right"
    },
    model: {
      value: (_vm.inputSeriesNum),
      callback: function($$v) {
        _vm.inputSeriesNum = $$v
      },
      expression: "inputSeriesNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "155px"
    },
    attrs: {
      "placeholder": "请输入本批次设备数",
      "size": "small"
    },
    model: {
      value: (_vm.inputNum),
      callback: function($$v) {
        _vm.inputNum = $$v
      },
      expression: "inputNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "请选择产品类型",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.Vervalue = ''
      }
    },
    model: {
      value: (_vm.Productvalue),
      callback: function($$v) {
        _vm.Productvalue = $$v
      },
      expression: "Productvalue"
    }
  }, _vm._l((_vm.ProductCodeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Productvalue != ''),
      expression: "Productvalue !=''"
    }],
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "请选择版本",
      "size": "small"
    },
    model: {
      value: (_vm.Vervalue),
      callback: function($$v) {
        _vm.Vervalue = $$v
      },
      expression: "Vervalue"
    }
  }, _vm._l((_vm.EditionCodeList[_vm.Productvalue]), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.Cteatloading
    },
    on: {
      "click": _vm.Create
    }
  }, [_vm._v("生成任务单")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "请输入任务单号",
      "prefix-icon": "el-icon-search",
      "size": "small"
    },
    model: {
      value: (_vm.SearchCode),
      callback: function($$v) {
        _vm.SearchCode = $$v
      },
      expression: "SearchCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.Refresh
    }
  }, [_vm._v("刷新")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading),
      expression: "listloading"
    }],
    staticStyle: {
      "width": "99.9%"
    },
    attrs: {
      "data": _vm.List,
      "border": "",
      "max-height": _vm.maxHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "serial_number",
      "label": "任务单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "产品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "edition",
      "label": "版本"
    }
  }), _vm._v(" "), (_vm.Limits.task_view || _vm.Limits.task_delete) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.Limits.task_view) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.GodownCode(scope.$index, scope.row)
            }
          }
        }, [_vm._v("详情\n        ")]) : _vm._e()]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar downtool",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.Pagesize,
      "current-page": _vm.Curpage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "下载二维码",
      "visible": _vm.QrcodeVisible,
      "fullscreen": true
    },
    on: {
      "update:visible": function($event) {
        _vm.QrcodeVisible = $event
      }
    }
  }, [(_vm.Limits.task_qrcodes) ? _c('el-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.DownAll
    }
  }, [_vm._v("\n      打包下载此单所有设备二维码\n    ")]) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading2),
      expression: "listloading2"
    }],
    attrs: {
      "data": _vm.List2,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "DID",
      "prop": "did"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "版本",
      "prop": "edition"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "颜色",
      "prop": "color"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "气弹簧",
      "prop": "spring"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.Pagesize2,
      "current-page": _vm.Curpage2,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fbbc9ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/EquipmentBelow.vue
// module id = 1295
// module chunks = 1